<template>
   <div>
           <BasePopUpDialog v-model="showSelectionDialog" @input="onCloseDlg(false)" 
           :maxBodyWidth="450" :persistent="false" :maxBodyHeight="400" 
           icon="event_note" title="Add/Edit Template">
                  <div slot="dialogBody">
                <v-form ref="form" class="mainForm">
                     <v-radio-group row v-model="editMode">
                            <v-radio label="Add Template" value="add" ></v-radio>
                            <v-radio label="Edit Template" value="edit" ></v-radio>
                    </v-radio-group>
                    <v-select
                    dense
                    hide-detail
                    v-model="issueTypeId"
                    :items="commIssueTypeList"
                    item-text="displayName"
                    item-value="id"
                    label="Issue Types"
                    class="mt-1 mb-0 ml-3 mr-3"
                    :rules="valueRequiredRule">
                    </v-select>

                    <v-select
                    dense
                    hide-details
                    v-model="commTemplateTypeId"
                    :items="announcementTypes"
                    item-text="displayName"
                    item-value="id"
                    label="Announcement Types"
                    class="mt-1 mb-0 ml-3 mr-3"
                    v-if="editMode == 'edit'"
                    :rules="valueRequiredRule">
                    </v-select>

                    <v-text-field
                        dense
                        hide-details
                        v-model="commTemplateTypeText"
                        label="Announcement Type"
                        class="ml-3 mr-3"
                        v-else
                        :rules="valueRequiredRule"
                    ></v-text-field>
                </v-form>
                  </div>
                    <div slot="dialogFooter">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="step1Validate">
                            Next
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="onCloseDlg(false)">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                 </div>
            </BasePopUpDialog>
            <BasePopUpDialog v-model="showCreationDialog" :maxBodyWidth="800" 
            :retainFocus="false" :maxBodyHeight="450" icon="event_note" 
            :title="editMode == 'add'?'Add Template':'Edit Template'">
                     <div slot="dialogBody">
                    <v-form ref="creationForm" class="mainForm">
                         <v-text-field
                            :prefix="issueTypeText +' - '"
                            v-model="commTemplateTypeText"
                            label="Template"
                            class="mt-1 mb-0"
                            :rules="valueRequiredRule"
                        ></v-text-field>
                        <v-tabs v-model="bodyTab">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab>Body</v-tab>
                            <v-tab-item>
                                <TemplateEditor v-model="template" :variables="variables" :rules="valueRequiredRule" :height="300"></TemplateEditor>
                            </v-tab-item>
                            <v-tab>Update Body</v-tab>
                            <v-tab-item>
                                <TemplateEditor v-model="updateTemplate" :variables="variables" :height="300"></TemplateEditor>
                            </v-tab-item>
                        </v-tabs>
                    </v-form>
                     </div>
                 <div slot="dialogFooter">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="step2Validate">
                            Submit
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="onCloseDlg(true)">
                            Close
                        </v-btn>
                    </v-card-actions>
                 </div>
            </BasePopUpDialog>
   </div>
</template>

<script>
import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";
import TemplateEditor from "@/components/TemplateEditor.vue"

export default {
    name:"templateCreateDialog",
    props:["value"],
    components:{TemplateEditor,BasePopUpDialog},
    data(){
        return{
           showSelectionDialog:false,
           showCreationDialog:false,
           valueRequiredRule:[
              v => !!v || 'Required.',
            ],
           editMode:"edit",
           issueTypeId:null,
           commTemplateTypeId:null,
           commTemplateTypeText:"",
           templateType:"",
           template:null,
           updateTemplate:null,
           issueTypeText:null,
           bodyTab:null,

        }
    },
    watch:{
        value(val){
            if(val && !this.showSelectionDialog){
                this.initDialog();
                this.$store.dispatch("fetchCommunicationField");
                this.showSelectionDialog = true;
            }
        }
    },
    computed:{
        fields(){
            return this.$store.getters.getCommuicationFields;
        },
        announcementTypes(){
            if(this.issueTypeId != null){
                return this.commTemplateTypeList.filter( dataDelayTypes => dataDelayTypes.issueTypeId == this.issueTypeId);
            }else{
                return [];
            }
        },
        commIssueTypeList(){
            return (this.fields && this.fields.commIssueTypeList) ? this.fields.commIssueTypeList:[];
        },
        commTemplateTypeList(){
            return (this.fields && this.fields.commTemplateTypeList) ? this.fields.commTemplateTypeList:[];
        },
        variables(){
             return (this.fields && this.fields.commTemplateVariablesList) ? this.fields.commTemplateVariablesList.map(ele =>{
                 const e={};
                 e.text = ele.displayName;
                 e.value = ele.displayName;
                 return e;
             }):[];
        }
    },
    mounted(){
        this.initDialog();
        this.$store.dispatch("fetchCommunicationField");
    },
    methods:{
        onCloseDlg(confirm){
            if(confirm){
                 const confirmObject = {}
                    confirmObject.showDlg= true;
                    confirmObject.buttons={
                        OKButton:{
                            Caption:"OK"
                        },
                        CancelButton:{
                            Caption:"Cancel"
                        }
                    };
                    confirmObject.title="Warning";
                    confirmObject.type="Info";
                    confirmObject.message="Do you really want to leave? the unsaved changes will be lost.";
                    confirmObject.submitCallback =  this.closeDialog;
                    this.$store.dispatch("setConfirmDialogDetails",confirmObject);
                    return;
            }else{
                this.closeDialog();
            }
            
        },
        closeDialog(){
            if(this.$refs.creationForm){
                this.$refs.creationForm.$el.scrollTop = 0;
            }
            this.showSelectionDialog = false;
            this.showCreationDialog = false;
            this.$emit("input",false);
        },
        step1Validate(){
            const valid = this.$refs.form.validate();
            if(!valid) {
                return;
            }
            this.showSelectionDialog = false;
            this.issueTypeText = this.commIssueTypeList.filter(e => e.id == this.issueTypeId )[0].displayName;
            if(this.editMode == "add"){
                this.template = "";
                this.updateTemplate= "";
            }else{
                this.loadTemplate();
            }
            this.showCreationDialog = true;
        },
        async loadTemplate(){
            const response = await this.$store.dispatch("loadTemplate",this.commTemplateTypeId);
            if(response && !response.error){
                this.template = response.template;
                this.updateTemplate = response.updateTemplate;
                this.templateType = response.templateType;
                this.commTemplateTypeText = response.templateType;
            }
        },
        async step2Validate(){
            const valid = this.$refs.form.validate();
            if(!valid) {
                return;
            }
            if(this.template == null || this.template == ""){
                const infoObject = {};
                infoObject.showDlg = true;
                infoObject.buttons={
                    CloseButton:{
                        Caption:"Close"
                    }
                };
                infoObject.title="Information";
                infoObject.message="Please enter template body!";
                this.$store.dispatch("setConfirmDialogDetails",infoObject);
                return;
            }

            const commUpdate = {};
            commUpdate.issueTypeId = this.issueTypeId;
           
            if(this.editMode == "edit"){
                commUpdate.id = this.commTemplateTypeId;
            }  

            commUpdate.templateType = this.commTemplateTypeText;
            
            commUpdate.template = this.template;
            commUpdate.updateTemplate = this.updateTemplate != null?this.updateTemplate:"";
            await this.$store.dispatch("saveTemplate",{requestBody:commUpdate,userId:this.$store.getters.getUserId});
            this.onCloseDlg();
        },
        initDialog(){
            this.editMode = "edit";
            this.commTemplateTypeId = null;
            this.commTemplateTypeText = "";
            this.issueTypeId = null;
            this.template = null;
            this.updateTemplate = null;
            this.showCreationDialog = false;
            this.showUpdateBody = false;
            if(this.$refs.form){
                this.$refs.form.resetValidation();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.mainForm{
    padding-top: 16px;
}
.v-tab {
text-transform: none !important;
}
</style>
